module.exports = __webpack_public_path__ + "img/1495834601.19bdc651.jpg";